
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[...slugs]",
      function () {
        return require("private-next-pages/event/[...slugs].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[...slugs]"])
      });
    }
  